import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import cx from "classnames";
import { LOADING_TEXT } from "../../constants";
import skeletonStyles from "../skeleton.module.css";
import styles from "./subtitle.module.css";
export const Subtitle = ({ children , isPending =false , className ="" , fontSize  })=>/*#__PURE__*/ _jsx(Text, {
        fontSizeFixed: fontSize || "xs",
        className: cx(className, styles.subtitle, {
            [skeletonStyles.base]: isPending,
            [skeletonStyles.active]: isPending
        }),
        children: isPending ? LOADING_TEXT : children
    });
export default Subtitle;
